import { render, staticRenderFns } from "./ObjectManage.vue?vue&type=template&id=cf8cda4c&"
import script from "./ObjectManage.vue?vue&type=script&lang=js&"
export * from "./ObjectManage.vue?vue&type=script&lang=js&"
import style1 from "./ObjectManage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports